<template>
  <v-row justify="center">
    <v-dialog
      v-model="mDialog"
      width="600px"
    >
      <v-sheet
      border="md"
      class="px-6 py-2 text-white mx-auto"
     
    >
      <!-- <v-img src="../../assets/images/popup_logo.jpg" style="width: 250px;"/> -->
      <v-img src="../../assets/images/logo.png" style="width: 190px;"/>
      <v-divider class="mb-5 mt-2" color="red"></v-divider>
      <h4 class="text-h6 font-weight-bold mb-4 ">투자 유의 안내</h4>
      <p class="mb-8">
        최근 인피니티투자자문 및 당사 임직원명을 <b class="text-point">사칭</b>하여 투자권유를 하는 사례가 발생하고 있어 알려드립니다. 
        <br>
        <br>
        당사는 전화 또는 인터넷 등 매체를 이용하여 고객에게 투자를 권유하고 있지 않습니다. 
        <br>
        <br>
        당사와 당사 직원을 사칭한 투자사기에 주의를 부탁드립니다. 
        <br>
        <br>
        <br>
        <b class="text-body-1 font-weight-bold">
          <v-icon class="pb-1 pr-1" color="red">mdi-alarm-light</v-icon> 피싱 의심 문자, 메일, 전화를 받았을 경우<br>
        </b>
        <b class="text-button">
          <v-icon small class="pl-2 pb-1">mdi-arrow-right-bottom-bold</v-icon>인피니티투자자문 확인 전화 <v-icon small class="pb-1" color="black">mdi-phone-classic</v-icon> 02-784-7670<br>
          <v-icon small class="pl-2 pb-1">mdi-arrow-right-bottom-bold</v-icon>경찰 또는 금융감독원 신고 전화 <v-icon small class="pb-1" color="black">mdi-phone-classic</v-icon> 112, 1332
        
        
        </b>
        <br>
        <br>
      </p>
      <h3 class="text-h5 font-weight-bold mb-6 text-center">인피니티투자자문㈜</h3>
      <v-divider class="mb-3" color="red"></v-divider>


      <div class="d-flex justify-end align-center">
      <!--
        <v-btn 
          text
          @click="setCookieDialog"
          class="mr-1"
        >
          하루동안 보지않기
        </v-btn>
      -->
        <v-checkbox 
          hide-details
          v-model="ckbox"
          label="하루동안 보지않기">
        </v-checkbox>
        <v-btn
          class="ml-2"
          small
          outlined
          color="primary"
          @click="hideDialog"
        >
          확인
        </v-btn>
      </div>
    </v-sheet>
    <!--
      <v-card dark>
        <v-img src="../../assets/images/logo.png" />
        <v-card-actions class="white">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="setCookieDialog"
          >
            하루동안 보지않기
          </v-btn>
          <v-btn
            color="pink"
            @click="hideDialog"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    -->
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    data() {
      return {
        name: '',
        text: '',
        mDialog: false,
        ckbox: false
      }
    },
    created() {
    },
    methods: {
      showDialog(){
        this.mDialog = true;
      },
      hideDialog() {
        if(this.ckbox) {
          this.setCookieDialog();
        } else {
          this.mDialog = false;
        }
      },
      setCookieDialog() {
        //let d = new Date();                
        //d.setTime(d.getTime() + (1*24*60*60*1000)); // 1일
        let d = new Date(Date.now() + 86400e3); // 1일
        let expires = "expires="+ d.toUTCString();
        document.cookie = "isNotice;" + expires + ";path=/";

        this.mDialog = false;
      }
    }
  }
</script>

<style>
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.text-point {
  color: red;
  font-weight: 700 !important;
}
</style>